function showInfoLabel(text, time = 2000)
{
    $('.info-label').fadeIn().find('.info-label__text').text(text);
    setTimeout(function () {
        $('.info-label').fadeOut();
    }, time);
}

$(function () {
    const baseUri = '/favourites/';

    const routes = {
        add: baseUri + 'add',
        remove: baseUri + 'remove'
    }

    function assignClicks() {
        const items = document.querySelectorAll(".fav-handler");

        items.forEach(item => {
            if (!item.firstElementChild.classList.contains('added')) {
                item.onclick = () => addFavourite(item.dataset.id, item.dataset.type, item);
            } else {
                item.onclick = () => removeFavourite(item.dataset.id, item.dataset.type, item);
            }
        });
    }

    const addFavourite = function (id, type, element) {
        const data = {
            id: id,
            type: type
        };

        axios.post(routes.add, data)
            .then(response => {
                element.firstElementChild.classList.add('added');
                element.onclick = () => {};
                element.onclick = () => removeFavourite(id, type, element);

                showInfoLabel("Успешно добавлено в избранное!", 4000);
                updateCounter(response.data.count);
                const event = new CustomEvent('add-to-favorites', {detail: response.data.info});
                document.dispatchEvent(event);
            })
            .catch(error => {
                console.log(error);

                showInfoLabel("Что-то пошло не так!");
            })
    }

    const removeFavourite = function (id, type, element) {
        const data = {
            id: id,
            type: type
        };

        axios.post(routes.remove, data)
            .then(response => {
                element.firstElementChild.classList.remove('added');
                element.onclick = () => {};
                element.onclick = () => addFavourite(id, type, element);

                showInfoLabel("Успешно удалено из избранного!", 4000);
                updateCounter(response.data.count);
            })
            .catch(error => {
                console.log(error);

                showInfoLabel("Что-то пошло не так!");
            })
    }

    function updateCounter(count) {
        const counterEl = document.querySelector(".favourite-link .cart-count");

        counterEl.style.display = count ? "flex" : "none";
        counterEl.innerHTML = count;
    }

    assignClicks();
});
